import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getReportedNote = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}reported_notes/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getReportedNote;
